import { render, staticRenderFns } from "./editionC2.vue?vue&type=template&id=34216f7a&scoped=true&"
import script from "./editionC2.vue?vue&type=script&lang=js&"
export * from "./editionC2.vue?vue&type=script&lang=js&"
import style0 from "./editionC2.vue?vue&type=style&index=0&id=34216f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34216f7a",
  null
  
)

export default component.exports